import Vue from 'vue';

export default setting =>
  Object.keys(setting).reduce((viewModels, selector) => {
    const nodes = document.querySelectorAll(selector);
    if (nodes.length === 0) {
      return viewModels;
    }
    viewModels[selector] = Array.from(nodes).map(
      el =>
        new Vue({
          ...setting[selector],
          el,
        })
    );
    return viewModels;
  }, {});
